<template>
    <div class="results-wrapper" :style="style()" ref="this">
      <div class="result-header-wrapper">
        <ul class="row result-header">
          <li :class="{'col-5':1,'col-md-4':1,active:orderBy=='place'}">
            <span @click="()=>{if(orderBy=='place'){orderASC = !orderASC};orderBy='place';}">
              <material-icons class="sort-order" v-if="orderBy=='place'" :icon="orderASC?'arrow_upward':'arrow_downward'"/>
              Participants
            </span>
            <div style="position:relative;margin-top:5px">
              <material-icons class="search-icon" icon="search"/>
              <input type="text" class="athlete-search" placeholder="Search athlete or affiliate" v-model="keyword"/>
            </div>
          </li>
          <li v-if="startWorkouts==0" :class="{'col-auto':1,active:orderBy=='TotalPoints'}" style="width:90px;text-align:center">
            <span @click="()=>{if(orderBy=='TotalPoints'){orderASC = !orderASC};orderBy='TotalPoints';}">
              <material-icons class="sort-order" v-if="orderBy=='TotalPoints'" :icon="orderASC?'arrow_upward':'arrow_downward'"/>
              Total
            </span>
          </li>
          <li v-for="workout in workouts.slice(startWorkouts, endWorkouts)" :key="workout.Id" :class="{'col':1,active:orderBy==workout.Id}">
            <span @click="()=>{if(orderBy==workout.Id){orderASC = !orderASC};orderBy=workout.Id;}">
              <material-icons class="sort-order" v-if="orderBy==workout.Id" :icon="orderASC?'arrow_upward':'arrow_downward'"/>
              {{ workout.Name }}
            </span>
          </li>
        </ul>
        <ul class="row result-header-second">
          <li class="col-5 col-md-4" style="width:370px"><span style="display:inline-block;width:30px">#</span> Name</li>
          <li v-if="startWorkouts==0" class="col-auto" style="width:90px;text-align:center">Points</li>
          <li v-for="workout in workouts.slice(startWorkouts, endWorkouts)" :key="workout.Id" class="col">
            <ul class="row">
              <li class="col text-center">Points</li>
              <li class="col text-center">Rank</li>
              <li class="col-6 text-center">Time</li>
            </ul>
          </li>
        </ul>
      </div>
      <div class="carousel-controls">
        <div class="row">
        <div class="col-5 col-md-4"></div>
        <div v-if="startWorkouts==0" class="col-auto" style="width: 90px"></div>
        <div class="col">
        <button @click="prevWorkouts()" v-if="this.startWorkouts > 0" class="prev"><MaterialIcons icon="keyboard_arrow_left"/></button>
        <button @click="nextWorkouts()" v-if="this.endWorkouts < workouts.length" class="next"><MaterialIcons icon="keyboard_arrow_right"/></button>
        </div>
        </div>
      </div>
      <ul class="cc-leaderboard-results-table">
        <li v-for="(result, index) in getData()" :key="result.PtcpID" :class="{'row-even':index%2==0, 'row-odd': index%2==1}">
          <ul class="row cc-leaderboard-result" @click="participantDetail(result)">
            <li class="col-5 col-md-4">
              <div class="row">
                <div class="col-auto" style="width:30px">{{result.Place}}</div>
                <div class="col">
                  <span class="name"><strong>{{result.Name}}</strong><span class="affiliate">{{result.Affiliate}}</span></span>
                </div>
                <div v-if="showFlag" class="col-auto" style="width:30px">
                  <img :src="'https://competitioncorner.net/images/countryFlags/'+result.CountryCode.substring(0,2)+'.png'"/>
                </div>
              </div>
            </li>
            <li v-if="startWorkouts==0" class="col-auto" style="width:90px;text-align:center">{{result.TotalPoints}}</li>
            <li class="col" v-for="(WorkoutScores, index) in Object.values(result.WorkoutScores).slice(startWorkouts, endWorkouts)" :key="index">
              <ul class="row">
                <li class="col text-center">{{ WorkoutScores.Points}}</li>
                <li class="col text-center">{{ WorkoutScores.Rank}}</li>
                <li class="col-6 text-center" v-html="WorkoutScores.Res"></li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
      <modal v-model="showDetail">
        <div class="modal-header" v-if="currentParticipant">
          <div class="athlete-avatar" :style="{backgroundImage:'url(https://competitioncorner.net/' + currentParticipant.AvatarPath + ')',backgroundSize:'cover'}">
            <h3 v-if="currentParticipant.AvatarPath == ''" :style="{fontSize: '20px',lineHeight:'80px',margin:0,padding:0}">{{ getShortName(currentParticipant.Name) }}</h3>
          </div>
          <h2 :style="{margin:'15px 0 0', padding:0}">{{ currentParticipant.Name }}</h2>
          <h3 :style="{margin:'10px 0 0', padding:0, color:'#757575', fontSize:'13px'}">{{ currentParticipant.Affiliate }}</h3>
        </div>
        <div class="modal-content" v-if="currentParticipant">
          <ul class="row" style="padding:10px 0;">
            <li class="col-7 text-center" style="font-size:25px;line-height:30px">{{ currentParticipant.Place }}{{ getNumberCounter(currentParticipant.Place) }}<br/><span style="color:#757575;font-size:12px">Overall</span></li>
            <li class="col-5 text-center" style="font-size:25px;line-height:30px">{{ currentParticipant.TotalPoints }}<br/><span style="color:#757575;font-size:12px">Total Points</span></li>
          </ul>
          <ul class="row">
            <template v-for="(workout, workout_id) in currentParticipant.WorkoutScores">
              <li style="border-top:1px solid #e0e0e0;padding:5px 15px" class="col-7" :key="workout_id"><strong style="text-transform:uppercase">{{ getWorkoutName(workout_id) }}</strong><br/><span style="color:#757575;font-size:12px">Points: {{ workout.Points }}</span></li>
              <li style="border-top:1px solid #e0e0e0;padding: 5px 15px" class="col-5" :key="workout_id"><span class="workout-caption">{{ workout.Caption }}:</span> <span v-html="workout.Res"></span></li>
            </template>
          </ul>
        </div>
      </modal>
    </div>
</template>
<script>
import Modal from './Modal';
import MaterialIcons from './Icon.vue'
export default {
  props: {
    results: {
        type: Array,
        default: []
    },
    workouts: {
        type: Array,
        default: []
    },
    workoutsHeader: {
      type: Array,
      default: [] 
    },
    topX: {
      type: Number,
      default: 10
    },
    maxHeight: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      keyword: '',
      currentEvent: null,
      currentGroup: null,
      results: [],
      orderBy: 'place',
      orderASC: true,
      numberWorkoutsToShow: 2,
      startWorkouts: 0,
      endWorkouts: 3,
      appWidth: 0,
      showFlag: true,
      showDetail: false,
      currentParticipant: null
    }
  },
  mounted () {
    if(this.$refs.this){
      this.appWidth = this.$refs.this.clientWidth;
    }
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        if(this.$refs.this){
          this.appWidth = this.$refs.this.clientWidth;
        }
      });
    })
  },
  components: {MaterialIcons, Modal},
  methods: {
    style() {
      let style = {
        position: 'relative',
      };
      if(this.maxHeight){
        style.maxHeight = parseInt(this.maxHeight) + 'px';
        style.overflowX = 'hidden';
        style.overflowY = 'auto';
      }
      return style;
    },
    nextWorkouts(){
      this.startWorkouts += this.numberWorkoutsToShow
    },
    prevWorkouts(){
      this.startWorkouts -= this.numberWorkoutsToShow;
    },
    getData () {
      var results = JSON.parse(JSON.stringify(this.results));
      if(this.keyword){
        results = results.filter( a => {
          return (a.Name + a.Affiliate).toLowerCase().indexOf(this.keyword.toLowerCase()) !== -1
        })
      }
      if(this.orderBy == 'place'){
        results.sort((a,b) => {
          a._Place = a.Place || 999;
          b._Place = b.Place || 999;
          a._Place = parseInt(a._Place);
          b._Place = parseInt(b._Place);
          if(this.orderASC){
              return ((a._Place < b._Place) ? -1 : ((a._Place > b._Place) ? 1 : 0));
          }else{
              return ((a._Place > b._Place) ? -1 : ((a._Place < b._Place) ? 1 : 0));
          }
        })
      }
      else if(this.orderBy == 'TotalPoints'){
        results.sort((a,b) => {
          a._TotalPoints = a.TotalPoints || 0;
          b._TotalPoints = b.TotalPoints || 0;
          a._TotalPoints = parseInt(a._TotalPoints);
          b._TotalPoints = parseInt(b._TotalPoints);
          if(this.orderASC){
              return ((a._TotalPoints < b._TotalPoints) ? -1 : ((a._TotalPoints > b._TotalPoints) ? 1 : 0));
          }else{
              return ((a._TotalPoints > b._TotalPoints) ? -1 : ((a._TotalPoints < b._TotalPoints) ? 1 : 0));
          }
        })
      }
      else{
        var orderBy = 'workout_' + this.orderBy;
        results.sort((a,b) => {
          a.WorkoutScores[orderBy]._Points = a.WorkoutScores[orderBy].Points || 0;
          b.WorkoutScores[orderBy]._Points = b.WorkoutScores[orderBy].Points || 0;
          a.WorkoutScores[orderBy]._Points = parseInt(a.WorkoutScores[orderBy]._Points);
          b.WorkoutScores[orderBy]._Points = parseInt(b.WorkoutScores[orderBy]._Points);
          if(this.orderASC){
            return ((a.WorkoutScores[orderBy]._Points < b.WorkoutScores[orderBy]._Points) ? -1 : ((a.WorkoutScores[orderBy]._Points > b.WorkoutScores[orderBy]._Points) ? 1 : 0));
          }else{
            return ((a.WorkoutScores[orderBy]._Points > b.WorkoutScores[orderBy]._Points) ? -1 : ((a.WorkoutScores[orderBy]._Points < b.WorkoutScores[orderBy]._Points) ? 1 : 0));
          }
        });
      }
      return results.slice(0, this.topX);
    },
    participantDetail (participant) {
      this.currentParticipant = participant;
      this.showDetail = true;
    },
    getShortName(name){
      let shortName = '';
      name.split(' ').forEach(e => {
        if(e !== ''){
          shortName += e[0];
        }
      })
      return shortName;
    },
    getWorkoutName(workout_id) {
      let name = '';
      this.workouts.forEach(wk => {
        if(workout_id.indexOf(wk.Id) !== -1){
          name = wk.Name;
        }
      })
      return name;
    },
    getNumberCounter(num){
      if(num == 1){
        return 'st';
      }else if(num == 2){
        return 'nd';
      }else if(num == 3){
        return 'rd';
      }else{
        return 'th';
      }
    }
  },
  watch: {
    orderBy (){
      this.orderASC = true;
    },
    appWidth (val){
      if(val < 767){
        this.numberWorkoutsToShow = 1;
        this.showFlag = false;
      }else if(val >= 768 && val < 992){
        this.numberWorkoutsToShow = 2;
        this.showFlag = false;
      }else if(val >= 992){
        this.numberWorkoutsToShow = 3;
        this.showFlag = true;
      }
      this.startWorkouts = 0;
      this.endWorkouts = this.numberWorkoutsToShow;
    },
    startWorkouts (val){
      this.endWorkouts = val + this.numberWorkoutsToShow;
    }
  }
}
</script>
<style lang="scss" scoped>
  @import '@/assets/grid.scss';
  .sort-order{
    font-size: 13px;
  }
  input.athlete-search{
    border: 1px solid #e0e0e0;
    padding: 0 30px;
    font-size: 13px;
    border-radius: 0;
    line-height: 33px;
    &::-webkit-input-placeholder{
      color: #e3e3e3;
    }
    &::-moz-placeholder{
      color: #e3e3e3;
    }
    &:-ms-input-placeholder{
      color: #e3e3e3;
    }
  }
  .search-icon{
    position: absolute;
    font-size: 17px;
    line-height: 35px;
    left: 9px;
  }
  .arrow-up.icon {
    color: #000;
    position: absolute;
    margin-left: 10px;
    margin-top: 3px;
    width: 1px;
    height: 16px;
    background-color: currentColor;
  }
  .arrow-up.icon:before {
    content: '';
    position: absolute;
    left: -5px;
    top: 1px;
    width: 10px;
    height: 10px;
    border-top: solid 1px currentColor;
    border-right: solid 1px currentColor;
    -webkit-transform: rotate(-45deg);
            transform: rotate(-45deg);
  }
  ul.row{
    margin: 0;
    padding: 0;
    list-style: none;
  }
  .result-header-wrapper{
    position: sticky;
    top: 0;
    background-color: #fff;
    z-index: 9;
  }
  ul.result-header{
    //position: sticky;
    //top: 0;
    //background-color: #fff;
    //z-index: 9;
    border-right: 1px solid #e0e0e0;
    border-bottom: 1px solid #e0e0e0;
    li{
      border-top: 1px solid #e0e0e0;
      border-left: 1px solid #e0e0e0;
      padding: 10px 12px;
      span{
        font-weight: bold;
      }
    }
  }
  ul.result-header-second{
    border-right: 1px solid #e0e0e0;
    border-bottom: 1px solid #e0e0e0;
    >li{
      border-left: 1px solid #e0e0e0;
      font-size: 12px;
      color: #9E9E9E;
      padding: 5px 12px;
    }
  }
  li.row-odd{
    background: #fcfcfc;
  }
  ul.cc-leaderboard-result{
    border-right: 1px solid #e0e0e0;
    border-bottom: 1px solid #e0e0e0;
    >li{
      border-left: 1px solid #e0e0e0;
      padding: 5px 12px;
    }
    span.name{
      text-transform: uppercase;
      span.affiliate{
        display: block;
        color: #757575;
        font-size: 11px;
        text-transform: unset;
      }
    }
  }
  .results-wrapper{
    overflow: auto;
    position: relative;
    .carousel-controls{
      position: sticky;
      top: 50%;
      width: 100%;
      height: 0;
      button{
        background: rgba($color: #000000, $alpha: 0.5);
        border: 1px solid #e3e3e3;
        width: 40px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        padding: 0;
        opacity: 0.5;
        &:hover{
          opacity: 1;
        }
        i{
          display: block;
          font-size: 30px;
        }
        &.next{
          position: absolute;
          right: 0;
        }
      }
    }
  }
  ul.cc-leaderboard-results-table{
    margin: 0;
    padding: 0;
    list-style: none;
    >li{
      margin: 0;
      padding: 0;
    }
  }
  .modal-header{
    background-color: #f5f5f5;
    text-align: center;
    padding: 25px 0;
    height: 209px;
    .athlete-avatar{
      display: inline-block;
      width: 80px;
      height: 80px;
      background-color: #ddd;
      border-radius: 50%;
    }
  }
  .modal-content{
    position: relative;
    overflow: auto;
    max-height: calc(100vh - 365px);
  }
  .workout-caption{
    display: inline-block;
    width: 80px;
  }
</style>